import { atom } from 'jotai';

import {
  AnswerSource,
  SearchClickFeedbackData,
} from '@/_generated/api-clients/xp';

export const previewingSourceAtom = atom<{
  source: AnswerSource;
  text: string;
}>();

export const searchFeedbackContextAtom = atom<{
  queryId: string;
  provider?: SearchClickFeedbackData['query']['smart.provider'];
}>();
